"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promotionRefreshIntervalFallback = exports.isPxCaptchaEnabled = exports.PX_CAPTCHA_ENABLED = exports.MAX_ATAT_RETRY_COUNT = exports.ProductTypes = exports.cameraSkus = void 0;
// todo need a better way of determining this
exports.cameraSkus = [
    'SSCM1',
    'SSCM1-R',
    'SSCM2',
    'SSCM2-INC',
    'CMOB1' // outdoor cam
];
// see https://www.typescriptlang.org/docs/handbook/enums.html#objects-vs-enums
exports.ProductTypes = {
    Accessory: 'accessory',
    BaseStation: 'base-station',
    PackageParent: 'package_parent',
    Sensor: 'sensor',
    Service: 'service',
};
exports.MAX_ATAT_RETRY_COUNT = 3;
exports.PX_CAPTCHA_ENABLED = process.env.PX_CAPTCHA_ENABLED;
const isPxCaptchaEnabled = () => exports.PX_CAPTCHA_ENABLED;
exports.isPxCaptchaEnabled = isPxCaptchaEnabled;
// 5 minutes in milliseconds
exports.promotionRefreshIntervalFallback = 5 * 60 * 1000;
//# sourceMappingURL=constants.js.map